import { ModificaCatalogoComponent } from './../../components/modifica-catalogo/modifica-catalogo.component';
import { Ricerca } from './../../models/ricerca.model';
import { MessageService } from './../../services/message.service';
import { environment } from './../../../environments/environment';
import { LocalStorageService } from './../../services/storage.service';
import { BookCollection, description } from './../../models/books.model';
import { BookService, filters } from './../../services/book.service';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import * as _ from 'lodash';

import { _MatTabGroupBase } from '@angular/material/tabs';
import { MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Wbook } from 'src/app/models/wbook';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-catalogo',
    templateUrl: './catalogo.component.html',
    styleUrls: ['./catalogo.component.scss'],
    animations: []
})
export class CatalogoComponent implements OnInit {
    public book;
    public books: any = [];
    public booksPage: any = [];
    public loader = false;
    public page = 0;
    public selectedAuthor = '';
    public selectedCollana = '';
    public selectedArgomento = '';
    public search = '';
    public searchField = 'titolo';
    public defaultOrder = 'prevista_pubb';
    public defaultSort = 'desc';
    public option = 'view';
    salvaModifiche = false;
    flip: string = 'default';
    public stati = [
        { cod: 'P', descrizione: 'Disponibile' },
        { cod: 'E', descrizione: 'Esaurito' },
        { cod: 'R', descrizione: 'Ristampa' },
        //   { cod: 'I' , descrizione: 'In produzione'}
    ];
    animation = '';
    public links = [];
    searchCtrl = new FormControl();
    ricerca: Ricerca = {
        fields: [

            {
                field: 'titolo',
                option: {
                    type: 'text',
                }
            },
            {
                field: 'ean',
                option: {
                    type: 'text',
                }
            },
            {
                field: 'anno_pubblicazione',
                option: {
                    type: 'text',
                }
            },
            {
                field: 'autore',
                option: {
                    type: 'select',
                    list: []
                }
            },
            {
                field: 'collana',
                option: {
                    type: 'select',
                    list: []
                }
            },
            {
                field: 'stato',
                option: {
                    type: 'select',
                    list: []
                }
            }
        ],
    };

    selectedBook = null;
    catalogoloaded = null;

    constructor(
        private bookservice: BookService,
        private storage: LocalStorageService,
        private messageservice: MessageService,
        private toast: ToastrService,
    ) {
        this.searchCtrl.valueChanges.subscribe((data: string) => {
            this.search = data;
            this.getBooks(0);
        });

    }
    ngOnInit(): void {
        // devo gestire l'evento
        // quando arriva l'evento scrivo nello storage, qualcosa come loaded e faccio getCached
        // 
        this.catalogoloaded = this.storage.get('catalogo-loaded');
        if (this.catalogoloaded === true) {
            this.getCached();
        } else {
            this.messageservice.listenEvent().subscribe((message) => {
                if (message.event === 'catalogo-loaded') {
                    this.getCached();
                }
            });
        }
    }
    // tslint:disable-next-line: typedef
    modifica() {
        this.option = 'edit';
    }

    // tslint:disable-next-line: typedef
    confirm() {
        this.salvaModifiche = true;
    }
    toggle(bookId): void {
        this.selectedBook = !bookId ? null : bookId
        this.option = 'view';
        this.salvaModifiche = false;
    }

    async getCached() {
        const cache = await caches.open(environment.cache);
        const response = await cache.match(this.bookservice.catalogoRequest());
        if (!response) {
            console.warn('[Catalogo] Cache miss: il catalogo non è in cache, ricarica la pagina dopo il login');
            return;
        }
        response.json().then((data) => {
            this.books = Array.isArray(data) ? data : (data.data || []);
            this.buildAutoriList();
            this.buildCollaneList();
            this.buildStatiList();
            this.getBooks(0);
        });
    }

    buildAutoriList() {
        const app = _.groupBy(this.books, 'cod_autore');
        const list: Array<description> = [];
        _.forEach(app, function (d) {
            if (d[0].cod_autore && d[0].autore) {
                list.push({
                    cod: d[0].cod_autore,
                    descrizione: d[0].autore,
                });
            }
        });
        const i = _.findIndex(this.ricerca.fields, { field: 'autore' });
        this.ricerca.fields[i].option.list = _.sortBy(list, 'descrizione');
    }

    buildCollaneList() {
        const app = _.groupBy(this.books, 'cod_collana');
        const list: description[] = [];
        _.forEach(app, function (d) {
            if (d[0].cod_collana && d[0].collana) {
                list.push({
                    cod: d[0].cod_collana,
                    descrizione: d[0].collana,
                });
            }
        });
        const i = _.findIndex(this.ricerca.fields, { field: 'collana' });
        this.ricerca.fields[i].option.list = _.sortBy(list, 'descrizione');
    }
    buildStatiList() {
        const app = _.groupBy(this.books, 'stato');
        const list: description[] = [];
        const _self = this;
        _.forEach(app, function (d) {
            list.push({
                cod: d[0].stato,
                descrizione: _self.getStato(d[0].stato),
            });
        });
        const i = _.findIndex(this.ricerca.fields, { field: 'stato' });
        this.ricerca.fields[i].option.list = _.sortBy(list, 'descrizione');
    }


    //riceve l'outuput del componente ricerca
    getSearchType(data: any) {
        if (data.event === 'search') {
            const field = data.field;
            switch (field) {
                case 'autore':
                    const au = _.findIndex(this.ricerca.fields, { field: 'autore' });
                    const indexAut = _.findIndex(this.ricerca.fields[au].option.list, r => String(r.cod) === String(data.value));
                    if (indexAut >= 0) {
                        this.getBooksAutore(data.value, this.ricerca.fields[au].option.list[indexAut].descrizione);
                    }
                    break;
                case 'collana':
                    const c = _.findIndex(this.ricerca.fields, { field: 'collana' });
                    const indexCol = _.findIndex(this.ricerca.fields[c].option.list, r => String(r.cod) === String(data.value));
                    if (indexCol >= 0) {
                        this.getBooksCollana(data.value, this.ricerca.fields[c].option.list[indexCol].descrizione);
                    }
                    break;
                case 'anno_pubblicazione':
                    this.search = data.value;
                    this.searchField = data.field;
                    this.getBooks(0);
                    break;
                case 'stato':
                    if (data.value !== '0') {
                        this.search = data.value;
                        this.searchField = data.field;
                        this.getBooks(0);
                    } else {
                        this.resetParameters();
                        this.getBooks(0);
                    }
                    break;
                case 'titolo':
                    this.search = data.value;
                    this.searchField = data.field;
                    this.getBooks(0);
                    break;
                case 'ean':
                    this.search = data.value;
                    this.searchField = data.field;
                    this.getBooks(0);
                    break;
            }
        } else if (data.event === 'order') {
            this.defaultOrder = data.field;
            this.defaultSort = data.value;
            this.getBooks(0);
        }
    }

    changePage($event): void {
        this.page = $event.pageIndex;
        this.getBooks(this.page);
    }

    resetParameters() {
        this.selectedArgomento = '';
        this.selectedAuthor = '';
        this.selectedCollana = '';
        this.search = '';
    }

    selectFromBook(e) {
        const event = e.event;
        const description = e.description;
        const cod = e.code;

        if (event === 'autore') {
            this.getBooksAutore(cod, description);
        }
        if (event === 'argomento') {
            this.getArgomento(cod, description);
        }
        if (event === 'collana') {
            this.getBooksCollana(cod, description);
        }
        this.selectedBook = null;
    }

    getArgomento(argomento, description) {
        this.resetParameters();
        this.selectedArgomento = argomento;
        this.getBooks(0);
        this.links = ['Catalogo', 'Per argomento ' + description];
    }

    getBooksCollana(collana, description) {
        this.resetParameters();
        this.selectedCollana = collana;
        this.getBooks(0);
        this.links = ['Catalogo', 'Per collana ' + description];
    }

    getBooksAutore(autore, description) {
        this.resetParameters();
        this.selectedAuthor = autore;
        this.getBooks(0);
        this.links = ['Catalogo', 'Per autore ' + description];
    }

    catalogo() {
        this.links = [];
        this.resetParameters();
        this.getBooks(0);
    }

    getBooks(pagina) {
        this.loader = true;
        const offset = pagina;
        const limit = 20;
        const search = this.search;
        const _s = this;
        this.books = _.orderBy(this.books, [this.defaultOrder], [this.defaultSort]);
        let allBooks = null;
        if (this.selectedCollana > '') {
            allBooks = _.filter(this.books, (o: any) => String(o.cod_collana) === String(this.selectedCollana));
        } else if (this.selectedArgomento > '') {
            allBooks = _.filter(this.books, (o: any) => String(o.cod_argomento) === String(this.selectedArgomento));
        } else if (this.selectedAuthor > '') {
            allBooks = _.filter(this.books, (o: any) => String(o.cod_autore) === String(this.selectedAuthor));
        } else {
            allBooks = _.filter(this.books, function (o) {
                if (o[_s.searchField] && o[_s.searchField].toLowerCase().includes(search.toLowerCase())) {
                    return o;
                }
            });
        }
        this.booksPage = _(allBooks).slice(offset * limit).take(limit).value();
        this.loader = false;
    }

    setAutori($event) {

    }


    formatData(data) {
        if (!data) return 'N.D.';
        const s = String(data);
        return s.length >= 6 ? (moment as any)(s, 'YYYYMMDD').format('DD-MM-YYYY') : 'N.D.';
    }

    ristampa(ean) {
        this.messageservice.setEvent({ type: 'menu', event: { link: 'novita' } });
        this.storage.set('ristampaBook', ean);
        /* this.bookservice.setRistampa(ean).subscribe((data: any) => { 
            const book = new Wbook();
            book.setValues(data);
            this.messageservice.setEvent({type: 'menu', event: { link: 'novita'}}); 
            this.storage.set('ristampaBook', book);

           // this.messageservice.setEvent({type: 'menu', event: { link: 'novita', action: 'ristampa', book : book}}); 
        }); */
    }

    getStato(stato) {
        /*  stati = [
            { cod: 'P' , descrizione:  'Disponibile'},
            { cod: 'E' , descrizione: 'Esaurito' },
            { cod: 'R' , descrizione: 'Ristampa'},
            { cod: 'I' , descrizione: 'In produzione'}
        ]; 
*/
        const o = _.find(this.stati, { 'cod': stato });

        if (o) {
            return o.descrizione;
        }


    }

    /**
     * Funzione che reimposta i filtri delle ricerca
     */
    resetForm(event) {
        if (event) {
            this.defaultOrder = 'data_pubblicazione'
            this.defaultSort = 'desc'
        }
    }

    downloadPdf(isbn) {
        const request = this.bookservice.schedaNovitaRequest(isbn.toString());
        fetch(request, { cache: "reload" })
            .then(response => {
                if (response.status != 404) {
                    response.blob().then(blob => {
                        const a = document.createElement('a');
                        a.href = URL.createObjectURL(blob);
                        a.download = `${isbn}.pdf`;
                        a.click();
                    });
                } else {
                    this.toast.warning('Scheda non presente');
                }
            });
    }

}
